import { FC } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { OPM_PD_BASE_PATH, REPORT_FOR_ADMIN_PATH } from '../../constants';
import BatchFilesPage from './BatchFiles/BatchFilesPage';

export const reportForAdminPath = `${OPM_PD_BASE_PATH}${REPORT_FOR_ADMIN_PATH}`;

const ReportForAdminRoutes: FC = () => {
  return (
    <Switch>
      <Redirect exact from={reportForAdminPath} to={`${reportForAdminPath}/batch-files`} />
      <PruRoute exact path={`${reportForAdminPath}/batch-files`} render={() => <BatchFilesPage />} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default ReportForAdminRoutes;
